(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-text-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-feature-carousel')) {
    class PdpFeatureCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.track = this.querySelector('.pdp-feature-cards__track');
        this.slides = Array.from(this.querySelectorAll('[data-feature-slide]'));
        this.pagination = this.querySelector('.pdp-feature-cards__pagination');
        this.dots = Array.from(this.querySelectorAll('[data-feature-slide-index]'));

        if (!this.track || this.slides.length < 2 || !this.pagination) return;

        this.initialized = true;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleScroll = this.handleScroll.bind(this);
        this.handlePaginationClick = this.handlePaginationClick.bind(this);
        this.handleModeChange = this.handleModeChange.bind(this);

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.pagination.addEventListener('click', this.handlePaginationClick);

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.handleModeChange);
        } else {
          this.mobileQuery.addListener(this.handleModeChange);
        }

        this.resizeObserver = new ResizeObserver(() => this.updateActiveDot());
        this.resizeObserver.observe(this.track);
        this.handleModeChange();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.track.removeEventListener('scroll', this.handleScroll);
        this.pagination.removeEventListener('click', this.handlePaginationClick);

        if (this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.handleModeChange);
        } else {
          this.mobileQuery.removeListener(this.handleModeChange);
        }

        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        this.initialized = false;
      }

      handleModeChange() {
        const isMobile = this.mobileQuery.matches;

        if (isMobile) {
          this.setAttribute('role', 'region');
          this.setAttribute('aria-label', 'Product features');
          this.setAttribute('aria-roledescription', 'carousel');
          this.track.setAttribute('tabindex', '0');
        } else {
          this.removeAttribute('role');
          this.removeAttribute('aria-label');
          this.removeAttribute('aria-roledescription');
          this.track.removeAttribute('tabindex');
          this.track.scrollLeft = 0;
        }

        this.slides.forEach((slide, index) => {
          if (isMobile) {
            slide.setAttribute('aria-label', `${index + 1} of ${this.slides.length}`);
            slide.setAttribute('aria-roledescription', 'slide');
          } else {
            slide.removeAttribute('aria-label');
            slide.removeAttribute('aria-roledescription');
          }
        });

        this.updateActiveDot();
      }

      handleScroll() {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateActiveDot());
      }

      handlePaginationClick(event) {
        const dot = event.target.closest('[data-feature-slide-index]');
        if (!dot || !this.pagination.contains(dot)) return;

        const index = Number(dot.dataset.featureSlideIndex);
        const slide = this.slides[index];
        if (!slide) return;

        const left = slide.offsetLeft - this.slides[0].offsetLeft;
        this.track.scrollTo({
          left,
          behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth',
        });
      }

      updateActiveDot() {
        if (!this.mobileQuery.matches) {
          this.setActiveDot(0);
          return;
        }

        const trackLeft = this.track.getBoundingClientRect().left;
        const activeIndex = this.slides.reduce((closestIndex, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          const closestDistance = Math.abs(this.slides[closestIndex].getBoundingClientRect().left - trackLeft);
          return distance < closestDistance ? index : closestIndex;
        }, 0);

        this.setActiveDot(activeIndex);
      }

      setActiveDot(activeIndex) {
        this.dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }

    customElements.define('pdp-feature-carousel', PdpFeatureCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
